<template>

    <div class="container">
        <h2>{{ lang('all.bestelling', {'%number%': order.data.number}) }}</h2>

        <confirmation-table
            :order="order"
        ></confirmation-table>

        <a
            :href="route('auth.myaccount.orders.show', order.data.uuid)"
            class="btn btn-primary"
        >
            {{ lang('all.bestelling_bekijken') }}
        </a>
    </div>

</template>

<script>

import Layout from "../../../Shared/Layout";
import ConfirmationTable from "../../../components/Orders/ConfirmationTable";

export default {

    components: {
        ConfirmationTable,
    },

    layout:Layout,

    metaInfo() {
        return {
            title:'Bestelling #' + this.order.data.number,
        }
    },

    name:'AuthOrdersShow',

    props: {
        order: {
            required:true,
        },
    },

}

</script>
